<template>
  <div class="topic" mg-stat-mod="topiclist">
    <fixed-header
        :shareContent="shareContent"
        :weixinShare="true"
        title="芒果好物"
    ></fixed-header>
    <div
        :style="type === 2 ? 'padding:0' : ''"
        class="topic__main scroll-touch"
    >
      <div v-if="type === 1" class="topic__banner">
        <img :src="data.positionCode"/>
      </div>
      <div
          :class="['topic__goods', `topic_type_${type}`]"
          :style="
          type === 2 ? 'background-image:url(' + data.positionCode + ');' : ''
        "
          mg-stat-mod="topiclist"
      >
        <div
            v-if="type === 2 && data.positionBtnImg"
            class="topic__tip"
            @click="showModal = true"
        >
          <img :src="data.positionBtnImg"/>
        </div>
        <div
            v-for="(item, index) in data.goodsList"
            v-if="type === 1"
            :key="index"
            :class="['topic__goods-item', getClass(index)]"
            :mg-stat-custom="`cont=${item.goodsId}&label=goods&direct=cntp&addr=haowu_goods_detail`"
            :mg-stat-lob="`sp_id=${id}&goodsdc=${goodsdc}`"
            mg-stat-click
            @click="gotoGoodsDetail(item)"
        >
          <section
              :mg-stat-lob="`smod=1&sp_id=${id}&goods_id=${item.goodsId}&stype=2`"
              class="topic__goods-img"
              mg-stat-show="flag=200"
          >
            <img :src="item.originalImg"/>
          </section>
          <div class="topic__goods-desc">
            <section class="add_dot2">{{ item.goodsName }}</section>
            <section class="topic__tags">
              <span v-for="(item, index) in item.tags" :key="index">{{
                  item
                }}</span>
            </section>
            <section>
              <div>
                <span>{{ handleJavaGoodsPrice(item) }}</span>
                <span>¥{{ item.marketPrice }}</span>
              </div>
            </section>
          </div>
        </div>
        <div
            v-for="(item, index) in data.goodsList"
            v-if="type === 2"
            :key="index"
            :class="['topic__goods-item']"
            @click="gotoCrowd(item.id)"
        >
          <section
              :mg-stat-lob="`smod=1&sp_id=${id}&goods_id=${item.goodsId}&stype=2`"
              :style="'background-image:url(' + item.spCode + ')'"
              class="topic__goods-img"
              mg-stat-show="flag=200"
          >
            <p class="name">{{ item.spName }}</p>
            <p class="join_num">支持人次：{{ item.joinNum }}</p>
          </section>
        </div>
      </div>
    </div>
    <mt-popup
        v-if="type === 2"
        v-model="showModal"
        class="topic__modal"
        position="middle"
    >
      <img :src="data.positionModalImg"/>
      <p @click="showModal = false"></p>
    </mt-popup>
    <nav-button></nav-button>
  </div>
</template>
<script>
import FixedHeader from 'components/common/FixedHeader';
import PageLoading from 'components/common/PageLoading';
import NavButton from 'components/common/NavButton';
import { handleJavaGoodsPrice } from 'utils/goods';
import { beforeRouteChange, initCloseUpload, setFixedParams, uploadAccessData, uploadCloseData } from 'utils/uploadData';
import DataStorage from 'utils/dataStore';
import { setWeixinShare } from 'utils/weixin';
import * as goodsApis from 'apis/goods';
import { guid } from 'utils/index';

export default {
  components: {
    FixedHeader,
    PageLoading,
    NavButton,
  },
  data() {
    const { id } = this.$route.query;
    return {
      id,
      data: {},
      type: 1,
      isShowSkuParams: false,
      goodsId: 0,
      shareContent: null,
      hasRouteChange: false,
      hasAnyAction: false,
      showModal: false,
      goodsdc: this.guid(),
    };
  },
  watch: {
    hasAnyAction: {
      handler(val) {
        DataStorage.setPageVisitiLog(val);
      },
      immediate: true,
    },
  },
  async created() {
    this.fetchTopicDetail();
    await setFixedParams(this);
    uploadAccessData();
  },
  mounted() {
    initCloseUpload();
  },
  beforeRouteLeave(to, from, next) {
    if (!this.hasRouteChange) {
      uploadCloseData();
    }
    next();
  },
  methods: {
    guid,
    handleJavaGoodsPrice,
    gotoGoodsDetail(item) {
      this.hasAnyAction = true;
      beforeRouteChange(
        {
          path: 'goods/detail',
          query: { id: item.goodsId, showBack: 1, goodsdc: this.goodsdc },
        },
        this,
      );
    },
    gotoCrowd(id) {
      this.hasAnyAction = true;
      this.hasAnyAction = true;
      beforeRouteChange({ path: 'cfDet', query: { id } }, this);
    },
    addCart(id) {
      this.goodsId = id;
      this.isShowSkuParams = true;
    },
    getClass(index) {
      return (index + 1) % 2 === 0 ? 'item-right' : 'item-left';
    },
    async fetchTopicDetail() {
      const data = await goodsApis.getTopicDetail({ specialId: this.id });
      if (data) {
        this.data = data;
        this.type = data.positionType;
        const {
          positionDesc, positionName, positionCode, shareImg,
        } = data;
        this.shareContent = {
          title: positionName,
          shareDesc: positionDesc,
          shareUrl: window.location.href,
          shareIcon: shareImg || positionCode,
        };
        setWeixinShare(this.shareContent);
      }
    },
  },
};
</script>
<style lang="scss">
.topic {
  height: 100%;

  .item-left {
    padding-right: 10px;
  }

  .item-right {
    padding-left: 10px;
  }

  &__main {
    padding: 20px 20px 120px 20px;
    box-sizing: border-box;
    height: 100%;
  }

  &__banner {
    height: 267px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  &__tip {
    position: absolute;
    top: 80px;
    right: 0px;

    img {
      width: 108px;
      height: auto;
    }
  }

  &__modal {
    img {
      width: 700px;
      height: auto;
    }

    p {
      position: absolute;
      width: 100px;
      height: 100px;
      top: 0px;
      right: 0px;
    }
  }

  &__modal.mint-popup {
    background-color: rgba(255, 255, 255, 0.001);
  }

  &__tags {
    height: 27px;
    overflow: hidden;

    span {
      height: 27px;
      box-sizing: border-box;
      line-height: 27px;
      border-radius: 12px;
      padding: 0px 12px;
      font-size: 16px;
      color: #ff5f00;
      background: rgba(255, 95, 0, 0.15);
      float: left;

      & + span {
        margin-left: 5px;
      }
    }
  }

  &__goods {
    display: flex;
    flex-wrap: wrap;

    &-item {
      width: 50%;
      margin-top: 20px;
      box-sizing: border-box;
    }

    &-desc {
      padding: 15px 10px;
      background: #fff;

      section {
        &:nth-of-type(1) {
          height: 75px;
          line-height: 1.4;
          font-size: 28px;
          /* padding: 10px 0; */
        }

        &:nth-of-type(3) {
          display: flex;
          justify-content: space-between;

          div {
            height: 50px;
            display: flex;
            align-items: center;
          }

          span {
            height: 100%;

            &:nth-of-type(1) {
              line-height: 55px;
              font-size: 34px;
              color: #ff5f00;
              margin-right: 10px;
            }

            &:nth-of-type(2) {
              line-height: 62px;
              font-size: 24px;
              color: #999999;
              text-decoration: line-through;
            }
          }

          span.member {
            text-decoration: none;
            margin-left: 10px;
            font-size: 22px;
            height: 32px;
            line-height: 32px;
            color: rgba(40, 35, 35, 1);
            background-size: 108px 32px;
            background-color: #faefe1;
            box-sizing: border-box;
            padding-right: 5px;
            border-radius: 4px;

            .vtag {
              line-height: 32px;
              padding: 2px 5px 3px 5px;
              height: 32px;
              text-decoration: none;
              border-top-left-radius: 4px;
              border-bottom-left-radius: 4px;
              font-size: 22px;
              color: #fff;
              background-color: #282323;
            }

            .tag {
              font-size: 12px;
              color: rgba(40, 35, 35, 1);
              text-decoration: none;
              border: none;
              margin-left: 2px;
            }
          }
        }
      }
    }

    &-img {
      height: 345px;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .topic_type_2 {
    background-repeat: no-repeat;
    background-size: 100% auto;
    position: relative;
    padding: 450px 20px 120px 20px;
    justify-content: space-between;

    .topic__goods-item {
      width: 226px;
    }

    .topic__goods-img {
      background-size: 100% auto;

      p {
        text-align: center;
      }

      .name {
        font-size: 32px;
        padding-top: 225px;
        font-size: 25px;
        font-weight: bold;
        color: rgba(255, 255, 255, 1);
        line-height: 30px;
      }

      .join_num {
        font-size: 20px;
        padding-top: 10px;
        font-weight: bold;
        color: rgba(255, 255, 255, 1);
        line-height: 37px;
      }
    }
  }
}
</style>
